<template>
  <div id="payment-form--financial-instrument-payrix">
    <v-layout row wrap>
      <v-flex xs12>
        <h2>Payment Information</h2>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12 md12>
        <InputPlaceholder
          identifier="cardName"
          display-name="Name on Card" />
      </v-flex>

      <v-flex xs12 md8>
        <InputPlaceholder
          identifier="cardNumber"
          display-name="Card Number"/>
      </v-flex>

      <v-flex xs12 md4>
        <InputPlaceholder
          identifier="securityCode"
          display-name="Security Code (CVV)" />
      </v-flex>

      <v-flex xs12 md4>
        <InputPlaceholder
          identifier="cardExpiration"
          display-name="Expiration Month/Year" />
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import InputPlaceholder from '@/components/Shared/InputPlaceholder.vue';

export default {
  components: {
    InputPlaceholder,
  },
  props: {
    paymentAmount: {
      type: [Number, String],
      required: true,
    },
    merchantId: {
      type: String,
      required: true,
    },
  },
  methods: {
    getToken(address) {
      /* eslint-disable no-undef */
      PayFields.config.billingAddress = address;
      return new Promise(resolve => {
        PayFields.onSuccess = response => {
          // console.debug('onSuccess', JSON.stringify(response.data[0], null, 4));
          resolve({
            valid: (response.data && response.data.length),
            data: response.data[0],
          });
        };
        PayFields.onFailure = response => {
          resolve({
            valid: false,
            data: response,
          });
        };
        PayFields.onValidationFailure = () => {
          resolve({
            valid: false,
            data: {},
          });
        };
        PayFields.submit();
      });
      /* eslint-enable no-undef */
    },
  },
  mounted() {
    const payrixScript = document.createElement('script');
    payrixScript.setAttribute('src', process.env.VUE_APP_PAYRIX_URL);
    payrixScript.onload = () => {
      /* eslint-disable no-undef */
      PayFields.config = {
        apiKey: process.env.VUE_APP_PAYRIX_APKI_KEY,
        merchant: this.merchantId,
        amount: this.paymentAmount,
        mode: 'token',
        additionalData: {},
        billingAddress: {},
      };
      PayFields.fields = [
        { type: 'name', element: '#input_cardName' },
        { type: 'number', element: '#input_cardNumber' },
        { type: 'cvv', element: '#input_securityCode' },
        { type: 'expiration', element: '#input_cardExpiration' },
      ];
      PayFields.customizations = {
        style: {
          '.input': {
            color: 'rgb(0 0 0 / 87%)',
            'font-size': '14px',
            'font-family': '"Open Sans", Helvetica, Arial, sans-serif',
            'line-height': '1.5',
            border: 'solid 1px rgba(0,0,0, 0.15)',
            'border-radius': '4px',
            padding: '1.65em 0.75em',
            'min-height': '40px',
            'box-sizing': 'border-box',
            width: '99%',
          },
          '.card-icon': {
            'padding-top': '6px',
          },
          '.form-error': {
            display: 'block',
            'padding-top': '0.4em',
            color: '#f8325a',
          },
        },
      };
      PayFields.jQuery(document)
        .ready(() => {
          PayFields.appendIframe();
          // PayFields.addWalletButtons();
        });
      /* eslint-enable no-undef */
    };
    document.head.appendChild(payrixScript);
  },
};
</script>
